import React from "react";
import { Handshake } from "lucide-react";
import PolicyShell from "../components/PolicyShell";

const SECTIONS = [
  {
    title: "Conduct expected of every member",
    items: [
      "Speak and act with respect toward every other member, regardless of caste, gender, age, faith, ability or background.",
      "Listen before responding. Disagreement is welcome; personal attacks and ridicule are not.",
      "Treat the Buddha's Dhamma and Babasaheb Dr. B. R. Ambedkar's writings as a shared inheritance, not a tool to claim authority over others.",
      "Honour the confidentiality of meetings: what is shared in pastoral or sangha settings stays there, unless safeguarding requires disclosure.",
    ],
  },
  {
    title: "Online conduct (meetings, chat, forum)",
    items: [
      "No discriminatory, hateful, threatening or harassing language. This includes caste-based slurs of any kind.",
      "No spamming, promotion of unrelated commercial products, or recruitment for other organisations without committee approval.",
      "Use your real name (or your chosen Sangha name) in meetings. Anonymous trolling is not permitted.",
      "Recordings of any meeting are made only with the explicit consent of participants.",
    ],
  },
  {
    title: "Conduct expected of volunteers & trustees",
    items: [
      "Act in the best interest of ABGN-UK at all times. Declare conflicts (see our Conflict of Interest Policy).",
      "Do not represent personal political views as ABGN-UK views. ABGN-UK is non-partisan.",
      "Hold any personal data of members in strict confidence (see our Privacy Policy).",
      "Set an example: practice the precepts as best you are able, and be patient with those who are new to the Dhamma.",
    ],
  },
  {
    title: "How breaches are handled",
    items: [
      "First breach: private conversation with a trustee, with the aim of restoration and learning.",
      "Repeated or serious breach: written warning and, if necessary, suspension from the relevant ABGN-UK activity.",
      "Egregious breach (harassment, discrimination, safeguarding violation, fraud): immediate removal from ABGN-UK and, where appropriate, referral to statutory authorities.",
      "Decisions can be appealed in writing to the chair. The committee will respond within 28 days.",
    ],
  },
];

export default function CodeOfConduct() {
  return <PolicyShell
    icon={Handshake}
    eyebrow="Policy"
    title="Code of conduct"
    intro="A simple set of expectations that helps the Sangha remain a welcoming, safe and kind space for every member, online and in person."
    sections={SECTIONS}
    approvedNote="Approved February 2026 · Reviewed annually."
  />;
}
